module.exports = __webpack_public_path__ + "static/media/pat-250x251.d2bbd9c2.png";